import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  MenuItem,
  TextField,
  List,
  ListItemButton,
  Divider
} from '@mui/material';
import api from '../../api/axios';
import HrEmployeeProfile from './HrEmployeeProfile';

const HRBranchEmployeeManagement = () => {
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState('');
  const [employees, setEmployees] = useState([]);
  const [selectedEmpId, setSelectedEmpId] = useState(null);

  /* LOAD BRANCHES */
  useEffect(() => {
    api.get('/branches')
      .then(res => setBranches(res.data))
      .catch(() => {});
  }, []);

  /* LOAD EMPLOYEES BY BRANCH */
  useEffect(() => {
    if (!branchId) return;
    api.get(`/hr/branches/${branchId}/employees`)
      .then(res => {
        setEmployees(res.data);
        setSelectedEmpId(null);
      })
      .catch(() => {});
  }, [branchId]);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" fontWeight={800}>
        Branch Employee Management
      </Typography>

      <Paper sx={{ p: 3, mt: 3 }}>
        <TextField
          select
          fullWidth
          label="Select Branch"
          value={branchId}
          onChange={e => setBranchId(e.target.value)}
        >
          {branches.map(branch => (
            <MenuItem key={branch.id} value={branch.id}>
              {branch.name}
            </MenuItem>
          ))}
        </TextField>

        <Divider sx={{ my: 2 }} />

        <List dense>
          {employees.map(emp => (
            <ListItemButton
              key={emp.id}
              selected={emp.id === selectedEmpId}
              onClick={() => setSelectedEmpId(emp.id)}
            >
              {emp.fullName} ({emp.employeeCode})
            </ListItemButton>
          ))}
        </List>
      </Paper>

      {/* EMPLOYEE PROFILE */}
      {selectedEmpId && (
        <HrEmployeeProfile employeeId={selectedEmpId} />
      )}
    </Box>
  );
};

export default HRBranchEmployeeManagement;
